import React, { ReactNode } from 'react';
import { useController } from 'react-hook-form';
import { MaterialSymbol } from '@/components/MaterialSymbol';
import { SettingsComponent } from '../../lib/declarations/EditorComponentTypes';
import { BlockSpecificPage } from '../../lib/declarations/BlockSpecificPage';
import { useCurrentBlock } from '../CurrentBlockProvider';
import ViewTypeSelector from '../../lib/components/settings/ViewTypeSelector';
import { KPBlockModel, KPViewType } from '../../../declarations/models/blocks/KPBlock';

const VARIANT_ICONS: Record<KPViewType, ReactNode> = {
  [KPViewType.GRID]: <MaterialSymbol name='view_module' />,
  [KPViewType.LIST]: <MaterialSymbol name='view_list' />,
  [KPViewType.MAP]: <MaterialSymbol name='map' />,
  [KPViewType.SIMPLE]: <MaterialSymbol name='view_headline' />,
};

export const PageBlockKPViewTypeSelector: SettingsComponent = () => {
  const { blockPath } = useCurrentBlock();

  const {
    field: { value: selectedViewType, onChange: setSelectedViewType },
  } = useController<BlockSpecificPage<KPBlockModel>, `${typeof blockPath}.view`>({ name: `${blockPath}.view` });

  return (
    <ViewTypeSelector
      viewType={selectedViewType}
      viewTypes={Object.values(KPViewType)}
      onChange={setSelectedViewType}
      variantIcons={VARIANT_ICONS}
      variantTranslationPath='DMViewTypeSelector'
    />
  );
};

export default PageBlockKPViewTypeSelector;
